// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "081157b825" + ".css";
};